import BadgeDelete from '@/screens/BadgeDelete';

export default function PrivateBadgeBadgeIdDeleteRoute() {
  return <BadgeDelete />;
}
